var map = {
	"./new-amex-big.svg": "rMWb",
	"./new-bankaxept-big.svg": "U0Yw",
	"./new-cup-big.svg": "jSXA",
	"./new-dankort-big.svg": "cH1h",
	"./new-diners-big.svg": "mhFe",
	"./new-discover-big.svg": "JEGs",
	"./new-interac-big.svg": "D259",
	"./new-invoice-big.svg": "XVpe",
	"./new-jcb-big.svg": "MB85",
	"./new-lindorff-big.svg": "ED3Q",
	"./new-maestro-big.svg": "kJxe",
	"./new-mastercard-big.svg": "nqeU",
	"./new-mobilepay-big.svg": "NILJ",
	"./new-vipps-big.svg": "79Kg",
	"./new-visa-big.svg": "jyWr"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Umpu";